import { getPlatform } from 'src/frontend-lib/tools/getPlatform'
import Bridge from 'src/frontend-lib/lib/Bridge'
import {
  getWXVersion,
  getIOSVersion,
  getAndroidVersion
} from '../../../../public-resource/libs/version'
import { versionfunegt } from 'src/frontend-lib/tools/utils.js'

const { isYixinliApp, isWechat, isIOS, isiPad, isAndroid } = getPlatform()

// 打卡小程序
export const WEAPP = 'gh_1eb06cd5c75c'

// 打卡的事件绑定
export default function(selector, successCD, failCD) {
  const isJOIN = window.baseInfo.is_join == '1'
  if (isYixinliApp) {
    // 是否是APP
    if (isJOIN) {
      // 是否购买该课
      bindAppEvent(selector, successCD, failCD)
    } else {
      bindLockEvent(selector)
    }
  } else if (!isWechat && !isYixinliApp) {
    // 环境不是微信或者壹心理APP
    bindOtherEvent(selector)
  } else {
    const text = isWXTemplate()
    if (text) {
      // 微信不兼容跳转小程序
      bindNotSupportEvent(selector, text)
    } else if (!isJOIN) {
      // 没有购买该课
      bindLockEvent(selector)
    }
  }
}

export function isWXTemplate() {
  if (versionfunegt('7.0.12', getWXVersion())) {
    return '跳转小程序需更新至微信最新版本，请更新微信至最新版本'
  } else if (isIOS || isiPad) {
    if (versionfunegt('10.3.0', getIOSVersion())) {
      return '跳转小程序需将ios版本更新至10.3或以上'
    }
  } else if (isAndroid) {
    if (versionfunegt('5', getAndroidVersion())) {
      return '跳转小程序需将安卓版本更新至5.0或以上'
    }
  }
}

function bindLockEvent(selector) {
  forBindEvent(selector, () => {
    window.toast('请先购买该课程')
  })
}

function bindAppEvent(selector, successCD, failCD) {
  const myBridge = new Bridge({
    methods: [
      {
        method: 'clockSelectorLaunchWXMiniProgram',
        callback: obj => {
          console.log('clockSelectorLaunchWXMiniProgram', obj)
          // const isDownloadSuccess = JSON.parse(val).success
          // console.log(val)
          // if (!isDownloadSuccess) {
          //   window.toast('打卡内容未上传，可微信联系助教', 3000)
          //   failCD && failCD(el)
          // } else {
          //   successCD && successCD(el)
          // }
        }
      }
    ]
  })
  forBindEvent(selector, dom => {
    const path = dom.getAttribute('data-url')
    if (path) {
      myBridge.call('launchWXMiniProgram', {
        callbackName: 'clockSelectorLaunchWXMiniProgram',
        userName: WEAPP, // 打卡小程序原始id
        path
      })
    } else {
      window.toast('打卡内容未上传，可微信联系助教', 3000)
    }
    successCD && successCD(dom)
  })
}

function bindOtherEvent(selector) {
  forBindEvent(selector, () => {
    window.toast('请在微信或者壹心理APP中打开')
  })
}

// 提示弹窗
function bindNotSupportEvent(selector, text) {
  forBindEvent(selector, () => {
    const popup = document.getElementById('tips-pop')
    const popupTips = document.getElementById('tips-pop-text')
    popupTips.innerText = text
    popup.style.display = 'flex'
  })
}

function forBindEvent(selector, cd) {
  const clocks = document.querySelectorAll(selector)
  for (let i = 0; i < clocks.length; i++) {
    clocks[i].addEventListener('click', function(e) {
      cd(this, e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/page-resource/lesson/compoents/clock/event.js